export const currentSortOrder = (): string =>
  // NOTE: 'start_time_asc' is the default sort order.
  new URL(document.location.href).searchParams.get('sort_order') || 'start_time_asc'
